import { motion } from "framer-motion";
import { HomeIcon } from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";

const BookingUnavailable = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center h-screen text-center p-6 bg-gray-100">
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="bg-white p-8 rounded-2xl shadow-xl max-w-md"
      >
        <HomeIcon className="w-20 h-20 text-gray-600 mx-auto mb-4" />
        <h1 className="text-2xl font-semibold text-gray-800 mb-2">
          Booking Unavailable
        </h1>
        <p className="text-gray-600 mb-6">
          We are currently constructing our lawns and farmhouse! Booking will be
          available soon. Stay tuned.
        </p>
        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="flex items-center gap-2 bg-blue-600 text-white px-6 py-3 rounded-full shadow-lg hover:bg-blue-700 transition"
          onClick={() => navigate("/")}
        >
          <HomeIcon className="w-5 h-5" /> Go Back Home
        </motion.button>
      </motion.div>
    </div>
  );
};

export default BookingUnavailable;
